import Icon from './Icon.tsx';
import { ComposedIconProps } from './Icon.tsx';
import url from '@assets/images/check.svg';

const CheckIcon = ({ icon = url, ...rest }: ComposedIconProps) => {
  return <Icon icon={icon} {...rest} />;
};

export default CheckIcon;
